import { AppScreen } from '@/components/ui/scene';
import { UnavailableState } from '@/components/ui/UnavailableState';
import { Stack, router } from 'expo-router';
import { CompassIcon } from 'lucide-react-native';

export default function NotFoundScreen() {
  return (
    <AppScreen>
      <Stack.Screen options={{ headerShown: false }} />
      <UnavailableState
        eyebrow="Wrong Turn"
        icon={CompassIcon}
        title="This page is off the route"
        body="The link you opened does not point to a live Radious screen anymore. Jump back into the feed or open the map and keep moving."
        primaryActionLabel="Browse events"
        onPrimaryAction={() => router.replace('/(tabs)/events')}
        secondaryActionLabel="Open map"
        onSecondaryAction={() => router.replace('/(tabs)/map')}
      />
    </AppScreen>
  );
}
